import { em } from 'polished'
import styled, { css } from 'styled-components'

import { TextSmallDescr } from 'styles/components/typography'

const labelWithFilling = css`
  color: ${p => p.theme.colors.white};
  background: ${p => p.theme.colors.grass};
  border-radius: ${p => p.theme.blocks.blockBorderRadius};

  ${({
    theme,
    theme: {
      typography: { textSmallDescrPx, cartFontSizePx },
    },
  }) => css`
    padding: ${em(1, textSmallDescrPx)} ${em(5, textSmallDescrPx)}
      ${em(2, textSmallDescrPx)};

    ${theme.mq.upLg} {
      padding: ${em(1, cartFontSizePx)} ${em(6, cartFontSizePx)}
        ${em(2, cartFontSizePx)};
    }
  `}
`

const LabelString = styled.span`
  line-height: ${p => p.theme.typography.textDisclaimerLh};
  font-family: ${p => p.theme.typography.mediumFont};
  font-weight: 400;
`

export const Value = styled(LabelString)`
  &:before {
    content: '-';
    display: inline;
  }
`

export const Text = styled(LabelString)`
  display: none;

  ${p => p.theme.mq.upLg} {
    display: ${props => (props.isShortLabel ? 'none' : 'inline')};
  }
`

export const Box = styled(TextSmallDescr)`
  position: relative;
  top: ${p => (p.isWithoutShift ? 0 : '-0.5em')};
  display: inline-block;
  color: ${p => p.theme.colors.grass};
  vertical-align: top;
  line-height: 0;
  white-space: nowrap;
  ${p => p.isWithFilling && labelWithFilling}

  ${p => p.theme.mq.upMd} {
    position: static;
    font-size: ${p => p.theme.typography.textSmallDescr};
    line-height: ${p => p.theme.typography.textSmallDescrLh};
    ${labelWithFilling}
  }

  ${p => p.theme.mq.upLg} {
    font-size: ${p => p.theme.typography.cartFontSize};
    line-height: ${p => p.theme.typography.textSmallDescrLh};
  }
`
